export default {
  list: { method: 'post', url: 'v1/movida/profile/list' },
  show: { method: 'post', url: 'v1/movida/profile/show' },
  linkScope: { method: 'post', url: 'v1/movida/profile/link_scope' },
  scopes: { method: 'post', url: 'v1/movida/profile/scopes' },
}